import React, { useEffect } from "react";
import {
  Col,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import { BaseButton, BaseInput } from "Components/ui"; // Ensure this component is properly defined
import { useFormik } from "formik";
import { CategoryValidationSchema } from "utils"; // Ensure your validation schema is defined
import { useGetCategoryById, useUpdateCategory } from "hooks/useCategories";
import { CategoryType } from "types"; // Ensure this type is correctly defined

// Define UpdateCategoryPayload type
type UpdateCategoryPayload = {
  id: string;
  data: CategoryType; // Use the original BranchType here
};

const EditCategoryModal = (props: {
  isOpen: boolean;
  toggle: () => void;
  categoryId: string;
}) => {
  const { isOpen, toggle, categoryId } = props;
  const { data: category, isLoading: isFetching } =
    useGetCategoryById(categoryId);
  const { mutate, isPending } = useUpdateCategory();

  // Formik setup
  const formik = useFormik({
    initialValues: {
      // id: Number(categoryId),
      name: "",
      description: "",
    },
    validationSchema: CategoryValidationSchema,
    enableReinitialize: true, // Allows form values to be updated with fetched data
    onSubmit: (values) => {
      // Create the payload directly with the required structure
      const payload: UpdateCategoryPayload = {
        id: categoryId,
        data: {
          // id: Number(categoryId),
          name: values.name,
          description: values.description,
          // status is not included in the payload sent to the API
        } as CategoryType,
      };

      console.log("Updating category with payload:", payload);

      // Call the mutate function with the corrected payload structure
      mutate(payload, {
        onSuccess: () => {
          formik.resetForm();

          toggle(); // Close modal on success
        },
      });
    },
  });

  // Populate form fields when the category data is loaded
  useEffect(() => {
    if (category) {
      formik.setValues({
        // id: category.id,
        name: category.name,
        description: category.description,
      });
    }
  }, [category]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true}>
      <ModalHeader toggle={toggle} tag="h4">
        Edit Category
      </ModalHeader>
      <ModalBody>
        {isFetching ? (
          <div className="text-centered">
            <Spinner />
          </div>
        ) : (
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col xs={12}>
                <div className="mb-3">
                  <BaseInput
                    label="Name"
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.name && !!formik.errors.name}
                    errorMessage={formik.errors.name}
                  />
                </div>
                <div className="mb-3">
                  <BaseInput
                    label="Description"
                    name="description"
                    type="textarea"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={
                      formik.touched.description && !!formik.errors.description
                    }
                    errorMessage={formik.errors.description}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <BaseButton
                    load
                    type="submit"
                    color="success"
                    className="save-customer"
                    loading={isPending}
                  >
                    Update Category
                  </BaseButton>
                </div>
              </Col>
            </Row>
          </Form>
        )}
      </ModalBody>
    </Modal>
  );
};

export default EditCategoryModal;
